// extracted by mini-css-extract-plugin
module.exports = {"text--pointer":"footerGiftcard_text--pointer__NDsLI"};